import * as React from "react";
import { useContext, useState } from "react";
import { ConditionalFileProps, QAPropsBase } from "../State";
import { store, validatorFn } from "../store";
import FileAnswer from "./FileAnswer";
import RadioAnswer from "./RadioAnswer";

// tslint:disable-next-line: interface-name
interface Props {
    propsBase: QAPropsBase;
    index: number;
    validator?: validatorFn;
}

const ConditionalFileAnswer: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch } = globalState;

    const [state, setState] = useState(false);
    return (
        <div className="quiz">
            <RadioAnswer index={props.index} propsBase={{ ...props.propsBase, answerValue: (props.propsBase.answerValue as ConditionalFileProps).answer }}
                onChange={(e, i, d) => {
                    setState(d!.value === "Yes");
                    dispatch({
                        type: "handle answer update",
                        index: props.index,
                        value: {
                            answer: d!.value,
                            files: (props.propsBase.answerValue as ConditionalFileProps).files
                        },
                        validator: props.validator
                    })
                }}
            />
            {
                state && <FileAnswer index={props.index} propsBase={{ ...props.propsBase, answerValue: (props.propsBase.answerValue as ConditionalFileProps).files }}
                    validator={props.validator} acceptedFileExtensions={props.propsBase.answerAdditionalData ? props.propsBase.answerAdditionalData.split(';')[0] : "*.*"}
                    disallowMultiple={props.propsBase.answerAdditionalData ? props.propsBase.answerAdditionalData.split(';')[1] === 'true' : false}
                onChange={(e, d) => {
                    dispatch({
                        type: "handle answer update",
                        index: props.index,
                        value: {
                            answer: (props.propsBase.answerValue as ConditionalFileProps).answer,
                            files: e.target.files
                        },
                        validator: props.validator
                    })
                }} />
            }
    </div>
  );
};

export default ConditionalFileAnswer;
